import React from 'react';
import PropTypes from 'prop-types';
import {Select} from 'rctui';

class ComboBox extends React.Component {
  static defaultProps = {
    disabled: false,
    options: [],
    name: '',
    value: ''
  };

  static propTypes = {
    name: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    let v = (value >= this.props.options.length) ? this.props.value : this.props.options[value].value;
    this.props.onChange(this.props.name, v);
  }

  render() {
    let data = [];
    let curId = this.props.options.length;

    for (let i = 0; i < this.props.options.length; i++) {
      let option = this.props.options[i];

      if (option.value === this.props.value) {
        curId = i;
      }

      data.push({id: i, text: i18n.get(option.label)});
    }

    if (curId == this.props.options.length) {
      data.push({id: curId, text: this.props.value});
    }

    if (this.props.sorted) {
      data.sort((a, b) => (a.text < b.text ? -1 : (a.text > b.text ? 1 : 0)));
    }

    return <Select grid={this.props.grid} value={curId} required filterAble
                   data={data}
                   onChange={this.onChange}
                   readOnly={this.props.disabled}
                   className={this.props.className}/>;
  }
}

export default ComboBox;



// WEBPACK FOOTER //
// ./src/js/Component/Form/ComboBox.jsx